// template for department outlet

import { Outlet } from "react-router-dom";

const outletIndex = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default outletIndex;
